var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDestinationPointIcon = function SvgDestinationPointIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#F4F4F4",
    rx: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.283 17.333c-.642 0-1.283-.35-1.575-.991l-.058-.175h-3.734a.53.53 0 0 1-.466-.234c-.117-.116-.117-.291-.117-.466l1.167-5.25a.57.57 0 0 1 .583-.467h2.8c.642 0 1.283.35 1.575.992l.058.175h3.734a.53.53 0 0 1 .466.233c.117.117.117.292.117.467l-1.167 5.25a.57.57 0 0 1-.583.466z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.158 19.667h-.116c-.292-.058-.525-.408-.467-.7l1.925-8.75c.058-.35.408-.525.7-.467.35.059.525.409.467.7l-1.925 8.75c-.117.292-.35.467-.584.467"
  })));
};
export default SvgDestinationPointIcon;